import _ from 'underscore';

const getFirstElement = (item) => {
  if (_.isArray(item)) {
    return _.first(item);
  }
  return item;
};

export const getImageListWithoutLogo = imageList => _.filter(imageList, imageArr =>
  getFirstElement(imageArr).isLogo !== true);

export const getDefaultCurrentSelectedImageId = (imageList) => {
  const imageListWithoutLogo = getImageListWithoutLogo(imageList);
  const firstImage = _.first(imageListWithoutLogo);

  return _.result(_.first(firstImage), 'BaseId');
};

const getLogoList = imageList => _.filter(imageList, imageArr =>
  getFirstElement(imageArr).isLogo === true);

export const getDefaultCurrentSelectedLogoId = (imageList) => {
  const logoList = getLogoList(imageList);
  const firstImage = _.first(logoList);

  return _.result(_.first(firstImage), 'Id');
};


export const getDefaultSelectedImageId = (imageList, isLogo) => (isLogo ? getDefaultCurrentSelectedLogoId(imageList) : getDefaultCurrentSelectedImageId(imageList));
